module.exports = __webpack_public_path__ + "img/1579443293.80ca6799.jpg";